import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FilterItems from './filterItems';
import { getAddFiltersDisplayStrategy } from '../../../strategies/displayStrategies/addFiltersDisplayStrategyFactory';
import { propExistsAndNonEmpty } from '../../../util/utils';
import { fetchAllFilters } from '../../../actions/filterActions';
import {
    receiveFilter,
    removeFilter,
} from '../../../actions/selectedFilter/inResultsActions';
import './addFiltersDisplay.scss';

class AddFiltersDisplay extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { assessment } = this.props;

        if (propExistsAndNonEmpty(assessment)) {
            this.props.fetchAllFilters(assessment.name, assessment.version);
        }
    }

    componentDidUpdate(prevProps) {
        const { assessment } = this.props;

        if (assessment !== prevProps.assessment) {
            this.props.fetchAllFilters(assessment.name, assessment.version);
        };
    }

    applyStrategy(filterGroups) {
        const { assessment } = this.props;

        const addFiltersDisplayStrategy = getAddFiltersDisplayStrategy(assessment.type);
        return addFiltersDisplayStrategy(assessment, filterGroups);
    }

    render() {
        const {
            removeFilter,
            receiveFilter,
            selectedFilters,
            assessment,
        } = this.props;

        let { filterGroups } = this.props;

        let filterCategories;
        if (filterGroups && propExistsAndNonEmpty(assessment)) {
            filterGroups = this.applyStrategy(filterGroups);

            filterCategories = filterGroups.map((filterGroup, idx) => {
                const category =
                    <div key={idx} className='border'>
                        <div className='filter-category-container'>
                            <span className={`category-name ${assessment.site}`}>{filterGroup.filterCategory}</span>
                                <FilterItems
                                    assessmentName={assessment.internalName}
                                    filterGroup={filterGroup}
                                    selectedFilters={selectedFilters}
                                    receiveFilter={receiveFilter}
                                    removeFilter={removeFilter}
                                    site={assessment.site}
                                />
                        </div>
                    </div>

                return category;
            });
        }

        return (
            <div className={`add-filters-display-container ${assessment.site}`}>
                {filterCategories}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        assessment: state.app.assessment,
        filterGroups: state.entities.filterGroups,
        selectedFilters: state.session.selectedFilters.inResults
    };
};

const mapDispatchToProps = dispatch => {
    return {
        receiveFilter: (filter) => dispatch(receiveFilter(filter)),
        removeFilter: (filter) => dispatch(removeFilter(filter)),
        fetchAllFilters: (asssessmentName, versionId) => dispatch(fetchAllFilters(asssessmentName, versionId)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddFiltersDisplay));